/**
 * ArrayBuffer → base64 for uploading structured artifacts (PSD / SVG /
 * PDF) to Fias. The naive `btoa(String.fromCharCode(...bytes))` blows
 * the call stack on multi-MB inputs (PSD layer data routinely runs
 * megabytes), so encode in fixed chunks.
 */

/** Chunk size for the fromCharCode pass. 32 KB stays well under the
 * argument-count limit `String.fromCharCode(...)` imposes while keeping
 * the loop count low for large buffers. */
const CHUNK = 0x8000;

/** Encode an ArrayBuffer to a base64 string (no data: prefix). */
export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i += CHUNK) {
    const slice = bytes.subarray(i, i + CHUNK);
    binary += String.fromCharCode(...slice);
  }
  return btoa(binary);
}
